import {
    ChangeDetectionStrategy,
    Component,
    HostListener,
    inject,
    ViewEncapsulation
} from '@angular/core';
import {
    MAT_SNACK_BAR_DATA,
    MatSnackBar,
    MatSnackBarRef
} from '@angular/material/snack-bar';
import {Router, NavigationEnd} from '@angular/router';
import {filter} from 'rxjs/operators';
import { MatIconModule } from "@angular/material/icon";
import { NgTemplateOutlet } from "@angular/common";
import { MatButton } from "@angular/material/button";

/**
 * Permet d'afficher une snackbar d'erreur en rouge
 */
@Component({
  selector: 'lib-pegase-snack-error',
  templateUrl: './snack-error.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, NgTemplateOutlet, MatButton],
  standalone: true
  // tslint:disable-next-line: no-host-metadata-property
})
@HostListener('mat-simple-snackbar')
export class SnackErrorComponent {
  public snackBarRef = inject(MatSnackBarRef<SnackErrorComponent>);
  public data = inject(MAT_SNACK_BAR_DATA);
  public router = inject(Router);

  /**
   * Constructeur de la snackbar
   */
  constructor() {
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe(() => this.snackBarRef.dismiss());
  }

  /**
   * Gestion de l'ouverture de la snackbar
   * @param snackBar la snackbar
   * @param error l'erreur à afficher
   * @param icon l'icône à afficher
   */
  public static open(
    snackBar: MatSnackBar,
    error: Error,
    icon = 'warning'
  ) {
    snackBar.openFromComponent(SnackErrorComponent, {
      data: { matIcon: icon, error: error },
      announcementMessage: error.message,
      duration: 30000,
      panelClass: 'error',
      verticalPosition: 'top',
      horizontalPosition: 'center',
    });
  }

  public getCauses() {
    return this.data['error'].causes;
  }
}
